<template>
  <div>
    <v-timeline-item color="red" small v-if="typeof evento === 'string'">
      <v-card color="background"> <strong>Evento: </strong> Permissão insuficiente para visualizar esse evento </v-card>
    </v-timeline-item>
    <v-timeline-item color="bluePcm" small v-else>
      <v-card color="background">
        <v-row dense>
          <v-col cols="12">
            <v-card-title>
              Evento: Transferência
            </v-card-title>
          </v-col>
        </v-row>
        <v-row align="center" align-content="center" dense>
          <v-col cols="4">
            <v-card-text> <strong>Status: </strong> {{ statusObject[`${evento.status}`] }} </v-card-text>
          </v-col>
          <v-col cols="4">
            <v-card-text>
              <strong>Data início: </strong>
              {{ convertDateFormat(evento.dateStartCall) }}
            </v-card-text>
          </v-col>
          <v-col cols="4">
            <v-card-text>
              <strong>Centro de Custo: </strong>
              {{
                evento.centroDeCusto
                  ? `${evento.centroDeCusto.codigo} - ${evento.centroDeCusto.description}`
                  : 'Sem Centro de Custo'
              }}
            </v-card-text>
          </v-col>
        </v-row>
        <v-row align="center" align-content="center" dense>
          <v-col cols="3">
            <v-card-text> <strong>Quem Transferiu: </strong> {{ evento.numeroOrigem }} </v-card-text>
          </v-col>
          <v-col cols="3">
            <v-card-text> <strong>Destino: </strong> {{ evento.numeroDestino }} </v-card-text>
          </v-col>
          <v-col cols="3">
            <v-card-text> <strong>Número Transferido: </strong> {{ evento.transferido }} </v-card-text>
          </v-col>
          <v-col cols="3">
            <v-card-text>
              <strong>Atendente: </strong>
              {{
                evento.acao && obtemAcao(evento.acao) === 'DiscarConferencia'
                  ? obtemConferencia(evento.atdCall)
                  : obtemAtendente(evento.atdCall, evento.numeroOrigem, evento.numeroDestino)
              }}
            </v-card-text>
          </v-col>
        </v-row>
        <v-divider class="ma-2" />
        <v-row align="center" align-content="center" dense>
          <v-col cols="4">
            <v-card-text>
              <strong>Concluída: </strong>
              <v-icon :color="evento.status === 'atendida' ? 'success' : 'darkRed'">
                {{ evento.status === 'atendida' ? 'mdi-check' : 'mdi-close' }}
              </v-icon>
            </v-card-text>
          </v-col>
          <v-col cols="4">
            <v-card-text> <strong>Ação: </strong> {{ obtemAcao(evento.acao) }} </v-card-text>
          </v-col>
          <Player
            v-if="
              ((evento.status === 'atendida' && evento.record) || (evento.status === 'naoAtendida' && evento.record)) &&
                permissaoOuvirLigacao
            "
            :file="
              obtemAcao(evento.acao) === 'DiscarConferencia'
                ? getAudioConference(`${evento.atdCall}-${evento.uniqueidCall}-${evento.linkedid}.wav`)
                : getAudio(evento.record)
            "
            :archive="evento.record"
            downloadable
            color="primary"
          />
        </v-row>
      </v-card>
    </v-timeline-item>
  </div>
</template>

<script>
import SimpleCrypto from 'simple-crypto-js'

import { sharedData } from '../_utils/sharedData'
import { sharedMethods } from '../_utils/sharedMethods'

import Player from './Player'

export default {
  name: 'TimeLineTransferencia',
  props: {
    evento: Object || String,
    centroDeCusto: Object,
  },
  components: { Player },

  data: () => ({
    ...sharedData,
    permissaoOuvirLigacao: false,
  }),

  created() {
    const simpleCrypto = new SimpleCrypto(process.env.VUE_APP_CRYPTO)

    const arrayPermissionsJSON = localStorage.getItem('pcm_permissions')
    const arrayPermissions = simpleCrypto.decrypt(arrayPermissionsJSON)

    if (
      arrayPermissions.includes(process.env.VUE_APP_RELATORIO_PABX_CHAMADAS_OUVIR_GRAVACAO) ||
      arrayPermissions.includes(process.env.VUE_APP_RELATORIO_PABX_CHAMADAS_TOTAL) ||
      arrayPermissions.includes(process.env.VUE_APP_ADMINISTRADOR)
    ) {
      this.permissaoOuvirLigacao = true
    }
  },

  methods: {
    ...sharedMethods,
  },
}
</script>
